module.exports = vendor_lib;


//////////////////
// WEBPACK FOOTER
// external "vendor_lib"
// module id = 9
// module chunks = 0